import { Injectable, inject } from "@angular/core";

import { LoggingService } from "@tylertech/core-module";
import { ExecutionResult, IAggregate, ICardAction, ICardData } from "@tylertech/tyler-api-types";

import { ActionReturn, IAggregateActionHandler } from "../interfaces";
import { AggregateHelperService } from "./aggregateHelperService";
import { AggregateActionHandlerRepository } from "./aggregateActionHandlerRepository";

// TODO - this is a very clear example of how abusing `any` types and allowing Multiple return type is a bad idea.....
export type AggregateActionResult = ActionReturn | ICardData | ICardAction | ExecutionResult<unknown> | boolean | undefined;

@Injectable()
export class AggregateActionService
{
    private readonly logger = inject(LoggingService);
    private readonly aggregateHelperService = inject(AggregateHelperService);
    private readonly aggregateActionHandlerRepository = inject(AggregateActionHandlerRepository);


    private getHandler(
        aggregate: IAggregate, cardData: ICardData, action: ICardAction): IAggregateActionHandler | undefined
    {
        return this.aggregateActionHandlerRepository.find(aggregate, cardData, action);
    }

    processAction(aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        const handler = this.getHandler(aggregate, cardData, action);
        if (!handler)
        {
            this.logger.warning(`No AggregateActionHandler found: Action was ${JSON.stringify(action)}`);
            return this.aggregateHelperService.performServerCardAction(aggregate, cardData, action);
        }

        return handler.execute(aggregate, cardData, action);
    }

    loadAction(aggregate: IAggregate, cardData: ICardData, action: ICardAction): void
    {
        const handler = this.getHandler(aggregate, cardData, action);
        if (handler)
        {
            handler.load(aggregate, cardData, action);
        }
    }
}

export function isCardData(obj: unknown): obj is ICardData
{
    return obj
        && typeof obj === "object"
        && "Id" in obj
        && "ActionProviderId" in obj;
}

export function isActionReturn(obj: unknown): obj is ActionReturn
{
    return obj && typeof obj === "object" && "success" in obj && "action" in obj;
}

export function isCardAction(obj: unknown): obj is ICardAction
{
    return obj
        && typeof obj === "object"
        && "Id" in obj
        && "actionType" in obj;
}

